import { Case } from '@/payload-types';

type FoodQuestionItem = {
    title: string;
    description: string;
    cases: { label: string; href: string }[];
};

const QUESTION_META: Record<string, { title: string; description: string }> = {
    eiwittransitie: {
        title: 'Eiwittransitie',
        description:
            'Hoe maken we de keuze voor plantaardig eten aantrekkelijk?',
    },
    voedselverspilling: {
        title: 'Voedselverspilling',
        description: 'Hoe voorkomen we dat voedsel wordt verspild?',
    },
    biodiversiteit: {
        title: 'Biodiversiteit',
        description:
            'Hoe kan wat we eten en drinken bijdragen aan meer biodiversiteit?',
    },
    'tech-en-innovatie': {
        title: 'Tech & innovatie',
        description:
            'Hoe kunnen we technologie inzetten om het voedselsysteem vooruit te helpen?',
    },
    'sociale-waarden': {
        title: 'Sociale waarden',
        description:
            'Hoe kun je eten en drinken gebruiken om de samenleving te verbinden?',
    },
    'klimaat-en-landbouw': {
        title: 'Klimaat & landbouw',
        description:
            'Hoe kunnen we voedsel verbouwen op een manier die positief bijdraagt aan het klimaat?',
    },
    'eerlijke-handel': {
        title: 'Eerlijke handel',
        description:
            'Hoe zorgen we voor een eerlijke prijs voor de makers van ons eten?',
    },
    'gezonde-omgeving': {
        title: 'Gezonde omgeving',
        description:
            'Hoe richt je een omgeving zo in dat deze uitnodigt tot gezond gedrag?',
    },
};

export function buildFoodQuestions(cases: Case[]): FoodQuestionItem[] {
    const questions: FoodQuestionItem[] = Object.values(QUESTION_META).map(
        ({ title, description }) => ({
            title,
            description,
            cases: [],
        }),
    );

    const byTitle = new Map(questions.map((q) => [q.title, q]));

    for (const c of cases) {
        const key = c.algemeneInformatie?.vraagstuk;
        const meta = key ? QUESTION_META[key] : undefined;
        if (!meta) continue;

        byTitle.get(meta.title)?.cases.push({
            label: c.titel,
            href: `/cases/${c.slug}`,
        });
    }

    return questions;
}
